import { clearCloak } from '../helpers/helpers';

export default {

  controller: function() { }

};